import { onBeforeUnmount } from 'vue';
import {
	useNativeHaptics,
	HapticsImpactStyle,
} from '/src/native/useNativeHaptics.js';

const { impact } = useNativeHaptics();

export function useHapticsService () {
	let handler;

	function start () {
		if (handler) return;

		handler = ({ target }) => {
			if (!(target instanceof Element)) return;

			const isButton = target.closest('button');

			if (isButton) {
				impact({ style: HapticsImpactStyle.Medium });
			}
		};

		document.addEventListener('mousedown', handler);
	}

	function stop () {
		if (handler) {
			document.removeEventListener('mousedown', handler);
			handler = null;
		}
	}

	onBeforeUnmount(() => stop());

	return {
		start,
		stop,
	};
}
